"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RouteService = exports.ROUTE_PREFIX = void 0;
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var route_recognizer_1 = tslib_1.__importDefault(require("route-recognizer"));
var login_page_1 = require("../page/auth/login.page");
var missing_page_1 = require("../page/missing.page");
var page_layout_1 = require("../page/page.layout");
var page_registry_1 = require("../page/page.registry");
var index_1 = require("./index");
exports.ROUTE_PREFIX = '#';
var RouteService = /** @class */ (function () {
    function RouteService() {
        this.__priority = 100;
        this.hasLoaded = false;
        this.tokensLoaded = false;
        this.profilesLoaded = false;
        this.params = mobx_1.observable.map({}, { deep: false });
    }
    RouteService.prototype.init = function () {
        var _this = this;
        (0, mobx_1.reaction)(function () { return _this.tokensLoaded; }, function () { return _this.firstLoad(); });
        (0, mobx_1.reaction)(function () { return _this.profilesLoaded; }, function () { return _this.firstLoad(); });
    };
    RouteService.prototype.bindRoutes = function () {
        var _this = this;
        this.router = new route_recognizer_1.default();
        for (var _i = 0, _a = page_registry_1.PageRegistry.pages; _i < _a.length; _i++) {
            var pageEntry = _a[_i];
            var paths = Array.isArray(pageEntry.config.path) ? pageEntry.config.path : [pageEntry.config.path];
            for (var _b = 0, paths_1 = paths; _b < paths_1.length; _b++) {
                var path = paths_1[_b];
                this.router.add([{ path: path, handler: pageEntry }]);
            }
        }
        this.layout = new page_layout_1.PageLayout();
        index_1.Services.Render.mount(index_1.Services.Window.document.body, this.layout, 'root');
        index_1.Services.Window.window.addEventListener('hashchange', function (ev) { return _this.resolveRoute(ev.newURL); });
    };
    // Once we check department tokens and get the user profile we resolve the route
    RouteService.prototype.firstLoad = function () {
        if (this.tokensLoaded && this.profilesLoaded && !this.hasLoaded) {
            this.hasLoaded = true;
            this.resolveRoute(window.location.href);
        }
    };
    RouteService.prototype.departmentReset = function () {
        this.tokensLoaded = false;
        this.profilesLoaded = false;
        this.hasLoaded = false;
    };
    Object.defineProperty(RouteService.prototype, "active", {
        get: function () {
            return this.layout != null ? this.layout.page : null;
        },
        enumerable: false,
        configurable: true
    });
    RouteService.prototype.supportDepartmentChange = function () {
        return this.active != null && this.active.config.supportDepartmentChange;
    };
    RouteService.prototype.setAllParams = function (params, history) {
        for (var _i = 0, _a = Object.keys(params); _i < _a.length; _i++) {
            var key = _a[_i];
            if (this.params.get(key) !== params[key]) {
                this.params.merge(params);
                this.applyParams(history);
                return;
            }
        }
    };
    RouteService.prototype.setParam = function (key, value, history) {
        if (this.params.get(key) !== value) {
            this.params.set(key, value);
            this.applyParams(history);
        }
    };
    RouteService.prototype.openNewWindow = function (name, params) {
        var url = this.getRouteURL(name, params);
        index_1.Services.Window.window.open(url, '_blank');
    };
    RouteService.prototype.getRouteURL = function (name, params) {
        var config = page_registry_1.PageRegistry.getConfig(name);
        if (config == null) {
            return undefined;
        }
        return this.compileURL(config, params);
    };
    RouteService.prototype.go = function (name, params) {
        var url = this.getRouteURL(name, params);
        this.goRaw(url);
    };
    RouteService.prototype.goRaw = function (url) {
        index_1.Services.Analytics.trackEvent(index_1.Services.Analytics.EventCategory.Route, 'route', url, 1);
        index_1.Logger.info({ url: url }, 'Routing');
        index_1.Services.Window.window.location.href = url;
    };
    RouteService.prototype.isPoleLoading = function () {
        // return this.route[1] === this.PAGE.dashboard.poleLoading;
        return true;
    };
    RouteService.prototype.isPoleStatus = function () {
        // return this.route[1] === this.PAGE.dashboard.poleStatus;
        return true;
    };
    RouteService.prototype.applyParams = function (history) {
        var $window = index_1.Services.Window.window;
        if ($window == null) {
            return;
        }
        var state = null;
        var title = null;
        var path = this.compileURL(this.active.config, this.params.toJSON());
        if (typeof $window.history.pushState === 'function') {
            if (history) {
                $window.history.pushState(state, title, path);
            }
            else {
                $window.history.replaceState(state, title, path);
            }
        }
        else {
            $window.location.href = path;
        }
    };
    RouteService.prototype.compileURL = function (config, params) {
        if (config.type === 'external') {
            return config.path;
        }
        var url = this.getMatchingPath(config, params);
        var paramsString = '';
        if (params != null && Object.keys(params).length > 0) {
            // Replace path params (/map/:location)
            var args_1 = {};
            for (var _i = 0, _a = Object.keys(params); _i < _a.length; _i++) {
                var key = _a[_i];
                if (params[key] != null) {
                    args_1[key] = params[key];
                }
            }
            url = url.replace(/:([^\/]+)/g, function (match, token) {
                var value = args_1[token];
                delete args_1[token];
                return value;
            });
            // Build query string (&foo=bar)
            if (Object.keys(args_1).length > 0) {
                paramsString = '?' + Object.keys(args_1)
                    .map(function (key) { return "".concat(index_1.Services.Window.window.encodeURIComponent(key), "=").concat(index_1.Services.Window.window.encodeURIComponent(args_1[key])); }).join('&');
            }
        }
        return "/".concat(exports.ROUTE_PREFIX).concat(url).concat(paramsString);
    };
    RouteService.prototype.getMatchingPath = function (config, params) {
        var paths = Array.isArray(config.path) ? config.path : [config.path];
        params = params || {};
        var matchingPath = paths[0];
        var matchCount = 0;
        for (var i = 0; i < paths.length; i++) {
            var args = paths[i].match(/:([^\/]+)/g) || [];
            var argMatchCount = 0;
            for (var _i = 0, args_2 = args; _i < args_2.length; _i++) {
                var arg = args_2[_i];
                if (params[arg.substr(1)] != null) {
                    argMatchCount += 1;
                }
            }
            if (argMatchCount > matchCount) {
                matchingPath = paths[i];
                matchCount = argMatchCount;
            }
        }
        return matchingPath;
    };
    RouteService.prototype.resolveRoute = function (url) {
        var path = url;
        if (!url.startsWith('/')) {
            if (url.includes(exports.ROUTE_PREFIX)) {
                path = url.split(exports.ROUTE_PREFIX).pop();
            }
            else {
                path = '/';
            }
        }
        var results = this.router.recognize(path);
        var page;
        var params = {};
        if (results == null || results.length === 0) {
            page = new missing_page_1.MissingPage();
        }
        else {
            var result = results[0];
            var pageEntry = result.handler;
            if (pageEntry.config.auth.required && !index_1.Services.User.isAuthenticated) {
                page = new login_page_1.LoginPage("/".concat(exports.ROUTE_PREFIX).concat(path));
            }
            else if ( // Check if the user has the correct tokens and/or user roles to access the requested page
            (pageEntry.config.auth.tokens && !index_1.Services.Token.hasAll(pageEntry.config.auth.tokens)) ||
                (pageEntry.config.auth.userLevel && !index_1.Services.UserProfile.isOneOf(index_1.Services.UserProfile.get(index_1.Services.User.current.objectId), pageEntry.config.auth.userLevel)) ||
                (pageEntry.config.auth.userLevelBlackList && index_1.Services.UserProfile.isOneOf(index_1.Services.UserProfile.get(index_1.Services.User.current.objectId), pageEntry.config.auth.userLevelBlackList))) {
                page = new missing_page_1.MissingPage(403);
            }
            else {
                page = new pageEntry.page();
            }
            params = tslib_1.__assign(tslib_1.__assign({}, result.params), results.queryParams);
        }
        var previousPage = this.layout.page;
        if (!previousPage || (previousPage && previousPage.config.name !== page.config.name)) {
            this.layout.setPage(page);
            this.params.replace(params);
            if (previousPage && this.layout.page !== previousPage) {
                previousPage.unload();
            }
        }
        page_layout_1.PageLayoutState.nav.setVisible(page.config.layout.nav);
    };
    tslib_1.__decorate([
        mobx_1.observable
    ], RouteService.prototype, "tokensLoaded", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], RouteService.prototype, "profilesLoaded", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], RouteService.prototype, "departmentReset", null);
    tslib_1.__decorate([
        mobx_1.action
    ], RouteService.prototype, "resolveRoute", null);
    return RouteService;
}());
exports.RouteService = RouteService;
//# sourceMappingURL=route.service.js.map